<template>
  <v-container>
    <v-container>
      <v-card>
        <v-card-title>{{ team.name }}</v-card-title>
        <TeamEditComponent :team="team" :isCreate="false" :allow-close="false" @snack="throwSnack">
        </TeamEditComponent>
      </v-card>
    </v-container>
  </v-container>
</template>

<script setup lang="ts">
import TeamEditComponent from '@/components/teams/TeamEditComponent.vue';
import { TeamDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useTeamStore } from '@/stores';
import { SNACKSTATUS } from '@/stores/util';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();
const teamId = computed(() => {
  return Array.isArray(route.params.teamId) ? route.params.teamId[0] : (route.params.teamId ?? '');
});
const teamStore = useTeamStore();
const { data } = teamStore.getTeamQuery(teamId);
const team = computed(() => data.value ?? new TeamDTO());

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
</script>
